import { createStore } from "vuex";

// 创建一个新的 store 实例
export const store = createStore({
  state() {
    return {
      articlesData: [],
      chosenImage: "",
    };
  },
  mutations: {
    setArticlesData(state, data) {
      state.articlesData = data;
    },
    setChosenImage(state, image) {
      state.chosenImage = image;
    },
  },
  actions: {
    updateArticlesData({ commit }, data) {
      commit("setArticlesData", data);
    },
    updateChosenImage({ commit }, image) {
      commit("setChosenImage", image);
    },
  },
  getters: {
    chosenImage: (state) => state.chosenImage,
  },
});
